import React, { FC, ReactNode, ReactElement } from 'react';
import classNames from 'classnames/bind';
import { IconCross } from 'components/Icons';
import styles from 'components/Modal/Modal.module.scss';

const cn = classNames.bind(styles);

interface ModalProps {
  children: ReactNode;
  onClose: () => void;
};

const Modal: FC<ModalProps> = ({ children, onClose }): ReactElement => {
  return (
    <div className={cn('modal')}>
      <div className={cn('modal__body')}>
        <div
          className={cn('modal__button-close')}
          onClick={onClose}
        >
          {IconCross}
        </div>
        {children}
      </div>
    </div>
  );
};

export { Modal };